export default (state, action) => {
  switch (action.type) {
    case 'REFRESH': {
      return action.payload;
    }

    case 'CLEAR_MAP': {
      return {
        ...state,
        mapData: {},
        mapDataCache: {},
      };
    }

    case 'CLEAR_MAP_CACHE': {
      let cache = state.mapDataCache;
      if (action.view === 'ALL') {
        cache = {};
      } else if (cache[action.view]) {
        delete cache[action.view];
      }
      return {
        ...state,
        mapData: cache,
      };
    }

    case 'FETCH_MAP': {
      return {
        ...state,
        mapData: {
          ...state.mapData,
          fsa: action.payload.fsa,
          postal: action.payload.postal,
        },
        mapDataCache: {
          ...state.mapDataCache,
          [action.view]: action.payload,
        },
        // loading: false,
        error: { text: '', status: false },
      };
    }

    case 'FETCH_HEATMAP': {
      return {
        ...state,
        mapData: {
          ...state.mapData,
          heatmap: action.payload.heatmap,
        },
        mapDataCache: {
          ...state.mapDataCache,
          [action.view]: action.payload,
        },
        error: { text: '', status: false },
      };
    }

    case 'FETCH_FLOWMAP': {
      return {
        ...state,
        mapData: {
          ...state.mapData,
          flowmap: action.payload.flow_map,
        },
        mapDataCache: {
          ...state.mapDataCache,
          [action.view]: action.payload,
        },
        error: { text: '', status: false },
      };
    }

    case 'GET_MOBILITY_DATES': {
      const { requestStatus, ...data } = action.payload;

      return {
        ...state,
        mobilityDates: data ?? state.mobilityDates,
        requestStatus: {
          ...state.requestStatus,
          initialDates: action.payload.requestStatus,
        },
      };
    }

    case 'SET_GEO_LOCATION': {
      return {
        ...state,
        geoLocation: action.payload.latitude
          ? {
              latitude: action.payload.latitude,
              longitude: action.payload.longitude,
            }
          : null,
      };
    }

    case 'GET_OOH_PANELS': {
      const { requestStatus, ...data } = action.payload;

      return {
        ...state,
        oohPanelData: data ?? state.oohPanelData,
        requestStatus: {
          ...state.requestStatus,
          oohPanels: action.payload.requestStatus,
        },
      };
    }

    case 'GET_OOH_RESULTS': {
      return {
        ...state,
        oohResults: action.payload,
      };
    }

    case 'GET_KML_GEOJSON': {
      return {
        ...state,
        kmlData: action.payload,
      };
    }

    case 'EXTRACT_OOH': {
      return {
        ...state,
        oohData: {
          ...state.oohData,
          [action.payload.oohType]: action.payload.ooh,
        },
      };
    }

    case 'GET_STORE_NAME': {
      return {
        ...state,
        storeName: action.payload.storeName ?? state.storeName,
        topStoreName: action.payload.topStoreName ?? state.topStoreName,
        storeCategories: action.payload.categories ?? state.categories,
        singleCategories:
          action.payload.singleCategories ?? state.singleCategories,
        brandNames: action.payload.brandNames ?? state.brandNames,
        requestStatus: {
          ...state.requestStatus,
          storeNames: action.payload.requestStatus,
        },
      };
    }

    case 'EXTRACT_STORES': {
      return {
        ...state,
        storeData: {
          ...state.storeData,
          [action.payload.poiName]: action.payload.stores,
        },
      };
    }

    case 'CLEAR_STORE_DATA': {
      return {
        ...state,
        storeData: {},
      };
    }

    case 'GET_DRIVE_TIME_LAYER':
      return {
        ...state,
        driveTimeLayer: action.payload,
      };

    case 'CLEAR_DRIVE_LAYER':
      return {
        ...state,
        driveTimeLayer: { type: 'FeatureCollection', features: [] },
      };

    case 'GET_OOH_ANALYTICS': {
      const newOOHAnalytics = action.payload;
      const updatedOOHAnalytics = { ...state.oohAnalytics };

      Object.keys(newOOHAnalytics).forEach((uidKey) => {
        if (!updatedOOHAnalytics[uidKey]) {
          updatedOOHAnalytics[uidKey] = newOOHAnalytics[uidKey];
        } else {
          updatedOOHAnalytics[uidKey] = {
            ...updatedOOHAnalytics[uidKey],
            ...newOOHAnalytics[uidKey],
          };
        }
      });

      return {
        ...state,
        oohAnalytics: updatedOOHAnalytics,
      };
    }

    case 'CLEAR_OOH_ANALYTICS':
      return {
        ...state,
        oohAnalytics: {},
      };

    case 'GET_RETAIL_ANALYTICS': {
      const newPoiAnalytics = action.payload;
      const updatedPoiAnalytics = { ...state.poiAnalytics };

      Object.keys(newPoiAnalytics).forEach((uidKey) => {
        if (!updatedPoiAnalytics[uidKey]) {
          updatedPoiAnalytics[uidKey] = newPoiAnalytics[uidKey];
        } else {
          updatedPoiAnalytics[uidKey] = {
            ...updatedPoiAnalytics[uidKey],
            ...newPoiAnalytics[uidKey],
          };
        }
      });

      return {
        ...state,
        poiAnalytics: updatedPoiAnalytics,
      };
    }

    case 'CLEAR_RETAIL_ANALYTICS':
      return {
        ...state,
        poiAnalytics: {},
      };

    case 'GET_RETAIL_FLOWMAP':
      return {
        ...state,
        retailFlowMap: action.payload.flow_map,
      };

    case 'SET_RETAIL_FLOWMAP':
      return {
        ...state,
        retailFlowMap: action.payload,
      };

    case 'CURRENT_PANEL':
      return {
        ...state,
        currPanel: action.payload,
      };

    case 'POPUP_VIEW':
      return {
        ...state,
        popupView: action.payload,
      };

    case 'CLEAR_POPUP_VIEW':
      return {
        ...state,
        popupView: false,
      };

    case 'SET_WORKFLOW_ID':
      return {
        ...state,
        workflowId: action.payload,
      };

    case 'CLEAR_WORKFLOW_ID':
      return {
        ...state,
        workflowId: null,
      };

    default:
      return state;
  }
};
